module.exports = __webpack_public_path__ + "static/media/mil5cart.072c716e.png";